module.exports = __webpack_public_path__ + "img/14.e8d29202.svg";